import styled from 'styled-components';

type Props = {
  $isPressable: boolean;
  $displayType: string;
};

export const Root = styled.td<Props>`
  position: relative;
  padding: 0;
  cursor: ${({ $isPressable }) => ($isPressable ? 'pointer' : 'default')};
  border-top: 1px solid ${({ theme }) => theme.colors.grey3};
  overflow: visible;
  &:hover {
    max-width: none;
    overflow: visible;
  }
`;

export const ContentContainer = styled.div<Props>`
  padding: 16px;
  display: ${({ $displayType }) => $displayType};
  align-items: center;
  vertical-align: middle;
  justify-content: ${({ $isPressable }) =>
    $isPressable ? 'flex-end' : 'inherit'};
`;

export const Content = styled.div`
  color: ${({ theme }) => theme.colors.grey9};
  font-size: 16px;
`;

export const Image = styled.img`
  margin-right: 10px;
  max-height: 40px;
`;
